export default function Footer() {
    return (
        <div className='mt-auto sticky z-40'>
            <footer className='fixed bottom-0 w-full bg-opacity-50 bg-amber-400 backdrop-blur-md'>
                <div className='text-black'>BeArt.hu</div>
            </footer>
        </div>
    )
}
